<template>
  <div class="vehicle-gallery-container">
    <div class="container">
    <slot name="header"></slot>
      <div class="row">
        <div
          v-if="mainImage && mainImage.content"
          class="col-md-9 main-image"
          :style="{ 'background-image': `url('${mainImage.content}')` }"
        >
        </div>
        <div class="col-md-3">
          <div class="vehicle-gallery">
            <div v-for="image of verticalImages" :key="image.id" class="item">
               <div class="item-image" @click="changeMainImage(image)" :style="{ 'background-image': `url('${image.content}'` }">
               </div>
            </div>
          </div>
        </div>
      </div>
      <slot name="footer"></slot>
    </div>
  </div>
</template>
<script>
export default {
  props: ['images'],
  created() {
    this.mainImage = this.images[0];
  },
  mounted() {
    $(".vehicle-gallery").slick({
      infinite: false,
      vertical: true,
      slidesToShow: 3,
      nextArrow:
        '<button type="button" class="slick-nav slick-next"><span></span></button>',
      prevArrow:
        '<button type="button" class="slick-nav slick-pre"><span></span></button>',
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            dots: true,
            arrows: false,
            vertical: false,
            verticalSwiping: false,
          },
        },
      ],
    });
  },
  data() {
    return {
      startIndex: 0,
      mainImage:
        "https://assets.rhinorack.com/Truckbed/Vehicles/Reconn-Deck-3.jpg",
    };
  },
  computed: {
    verticalImages() {
      return this.images;
    },
  },
  methods: {
    changeMainImage(img) {
      this.mainImage = img;
    },
  },
};
</script>
<style lang="scss">
.vehicle-gallery-container {
  h1,h2,h3,h4,h5,h6 {
    font-family: 'trim-medium';
    text-transform: uppercase;
  }
  background-color: white; 
  padding: 1rem 0 4rem 0;
  .item {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: .2rem;
    border: 1px solid #b2b2b22c;
    // padding: 1rem;
     .item-image {
      padding:33.33%;
      background-position:center;
      background-size:cover;
    }
  }
  .vehicle-gallery {
    display: flex;
    flex-direction: column;
    height: 100%;
    margin-top: 2.1rem;
  }

  button.slick-prev.slick-arrow {
    display: none;
    color: red !important;
  }

  .slick-dots {
    display: flex;
    justify-content: center;
    align-items: center;
    padding-left: 0;
    li {
      list-style-type: none;
      height: 0.8rem;
      width: 0.8rem;
      background-color: #d8d8d8;
      margin: 0.4rem;
      cursor: pointer;
      button {
        display: none;
      }
      &.slick-active {
        background-color: #005cb9;
      }
    }
  }
  .slick-nav {
    background-color: transparent;
    border: none;
    display: flex;
    justify-content: center;
    padding: 0.5rem;
    &.slick-next {
      display: flex;
      justify-content: center;
      span {
        background-color: transparent;
        border: solid #353535;
        border-width: 0 3px 3px 0;
        display: inline-block;
        width: 1rem;
        height: 1rem;
        transform: rotate(45deg);
      }
      &.slick-disabled {
         visibility: hidden;
      }
    }
    &.slick-pre {
      display: flex;
      justify-content: center;
      span {
        background-color: transparent;
        border: solid #353535;
        border-width: 0 3px 3px 0;
        display: inline-block;
        width: 1rem;
        height: 1rem;
        transform: rotate(225deg);
      }
      &.slick-disabled {
        visibility: hidden;
      }
    }
    
  }
  .main-image {
    display: flex; 
    justify-content: 
    center; align-items: center;
    border: 1px solid #b2b2b22c;
    margin-top: 2.1rem;
    margin-bottom: 3.5em; 
    height:600px;
    background-position:center;
    background-size:cover;
    background-repeat:no-repeat;

    @media screen and (max-width: 992px) {
      height:400px;
    }

    @media screen and (max-width: 768px) {
      display: none !important;
    }
  }
}
</style>